<template>
  <div>
    <!--顶部工具条-->
    <el-col :span="24">
      <el-form :inline="true">
        <el-form-item>
          <el-select
            style="width: 220px"
            v-model="filters.isClick"
            placeholder="请选择是否点击短信链接"
            clearable
          >
            <el-option
              v-for="item in isClickOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            style="width: 170px"
            v-model="filters.isRegistered"
            placeholder="请选择是否注册"
            clearable
          >
            <el-option
              v-for="item in isRegisteredOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            style="width: 170px"
            v-model="filters.sendStatus"
            placeholder="请选择发送状态"
            clearable
          >
            <el-option
              v-for="item in sendStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
        </el-form-item>
      </el-form>
    </el-col>
    <!--列表-->
    <el-table
      :data="tableData"
      highlight-current-row
      v-loading="listLoading"
      style="width: 100%"
      border
      @current-change="selectCurrentRow"
    >
      <el-table-column
        prop="smsNotificationTaskName"
        label="短信任务名称"
        align="center"
        show-overflow-tooltip
      ></el-table-column>

      <el-table-column
        prop="numberLibraryDetailId"
        label="号码库详情id"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="numberLibraryDetailName"
        label="号码库详情名称"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="token"
        label="今牌"
        width="340"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="numberName"
        label="号码姓名"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="phoneNumber"
        label="手机号"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="isClick"
        label="是否点击短信链接"
        align="center"
        show-overflow-tooltip
      >
        <template #default="scope">
          <el-tag type="success" v-if="scope.row.isClick == true">是</el-tag>
          <el-tag type="warning" v-if="scope.row.isClick == false">否</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="isRegistered"
        label="是否注册"
        align="center"
        show-overflow-tooltip
      >
        <template #default="scope">
          <el-tag type="success" v-if="scope.row.isRegistered == true"
            >是</el-tag
          >
          <el-tag type="warning" v-if="scope.row.isRegistered == false"
            >否</el-tag
          >
        </template></el-table-column
      >
      <el-table-column
        prop="sendStatus"
        label="发送状态:"
        align="center"
        show-overflow-tooltip
      >
        <template #default="scope">
          <el-tag type="info" v-if="scope.row.sendStatus == 0"
            >待发送</el-tag
          >
          <el-tag type="success" v-if="scope.row.sendStatus == 1"
            >发送成功</el-tag
          >
          <el-tag type="danger" v-if="scope.row.sendStatus == 2"
            >发送失败</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="sendTime"
        label="实际发送时间"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="errorMsg"
        label="发送失败原因"
        align="center"
                width="320"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>
    <!--底部工具条-->
    <el-col :span="24" class="pageBar">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pages.pageIndex"
        :page-sizes="pages.pageArr"
        :page-size="pages.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pages.dataCount"
      >
      </el-pagination>
    </el-col>
  </div>
</template>

<script>
import util from "../../../../util/date";
import { getSmsNotificationTaskDetailListPageApi } from "../../../api/api";

import Qs from "qs";
export default {
  data() {
    return {
      util: "",
      tableData: [],
      listLoading: false,
      //增删改查按钮
      buttonList: [],
      //顶部筛选条件
      filters: {
        smsNotificationTaskId: "",
        isClick:"",
        isRegistered:"",
        sendStatus:""
      },

      //关于分页的obj
      pages: {
        pageSize: 20, //默认每页条数
        pageArr: [10, 20, 30, 40], //默认每页条数选择
        pageIndex: 1, //默认进入页
        dataCount: 20, //默认总页数
      },

      isClickOptions: [
        {
          value: true,
          label: "是",
        },
        {
          value: false,
          label: "否",
        },
      ],
      isRegisteredOptions: [
        {
          value: true,
          label: "是",
        },
        {
          value: false,
          label: "否",
        },
      ],

      sendStatusOptions: [
        {
          value: 0,
          label: "待发送",
        },
        {
          value: 1,
          label: "发送成功",
        },
        {
          value: 2,
          label: "发送失败",
        },
      ],
    };
  },
  methods: {
    handleSearch(){
        this.pages.pageIndex = 1
        this.getList()
    },
    getList() {
      var params = {
        ...this.filters,
        pageIndex: this.pages.pageIndex,
        pageSize: this.pages.pageSize,
      };
      getSmsNotificationTaskDetailListPageApi(params).then((res) => {
        this.tableData = res.data.response.data;
        this.pages.dataCount = res.data.response.dataCount;
      });
    },

    selectCurrentRow(row) {
      this.currentRow = row;
    },

    formatCreateTime: function (date) {
      return !date || date == ""
        ? ""
        : util.formatDate.format(new Date(date), "yyyy-MM-dd");
    },

    // apply改变this指向
    callFunction(item) {
      this[item.func].apply(this, item);
    },
    // 分页
    handleCurrentChange(val) {
      this.pages.pageIndex = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pages.pageSize = val;
      this.getList();
    },
  },
  mounted() {
    this.filters.smsNotificationTaskId = this.$route.query.id;
    this.getList();
    this.util = util;
  },
};
</script>
<style lang="stylus" scoped>
.rolesTop {
  width: 100%;
  display: flex;
}

.rolesInp {
  width: 300px;
  margin-right: 20px;
}

.pageBar {
  margin-top: 15px;
}
</style>
